










import { Vue, Component } from 'vue-property-decorator';
import ReportesBajasTransitoBase from './ReportesBajasTransitoBase.vue';

@Component({ components: { ReportesBajasTransitoBase } })
export default class ReportesBajasTransitoPantalla extends Vue {}
